import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Course } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { ExperienceCoursesService } from '../../../experience-courses.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(pageService: ExperienceCoursesService, util: UtilityService, domainDataService: DomainDataService): GridSetup<Course> {
	return {
		rowName: { singular: 'Course', plural: 'Courses' },
		getRowKey: row => '' + row.courseVersionId,
		stateKey: 'programs-experience-courses-version-grid',
		actions: getActions(),
		buttons: getButtons(),
		columns: getColumns(util, domainDataService),
		renderRowClasses: row => [],
		multiselect: false,
	}
}
